<template>
	<az-container>
		<cabecalho-anuencia :anuencia="anuencia"></cabecalho-anuencia>
		<v-container>
			<v-row>
				<v-col cols="12" sm="8" offset-sm="2">
					<div class="mensagem-finalizar">
						<span v-if="naoConcluiu" class="box-aviso"
							><v-icon color="primary" class="mr-5">mdi-information</v-icon> Para concluir a operação,
							clique para finalizar.</span
						>
						<span class="justificativa" data-testid="justificativa-span" v-if="anuencia.justificativaRecusa"
							><b>Justificativa: </b>{{ anuencia.justificativaRecusa }}</span
						>
						<span class="box-aviso" v-else-if="!naoConcluiu" data-testid="informativo-finalizado-span"
							><v-icon color="primary" class="mr-5">mdi-information</v-icon> A anuência foi
							finalizada.</span
						>
						<v-btn
							v-if="naoConcluiu"
							color="primary"
							data-testid="finalizar-btn"
							large
							@click="finalizarAnuencia"
							>Finalizar</v-btn
						>
					</div>
				</v-col>
			</v-row>
		</v-container>
	</az-container>
</template>
<script>
import cabecalhoAnuencia from '@/views/pages/adesao/anuenciaFornecedor/components/cabecalho/CabecalhoAnuencia.vue'
import buscarAnuencia from '@/views/pages/adesao/anuenciaFornecedor/mixin/buscar-anuencia-mixin'
import { actionTypes, situacoes } from '@/core/constants'

export default {
	name: 'etapa-finalizar-anuencia',
	components: { cabecalhoAnuencia },
	mixins: [buscarAnuencia],
	data() {
		return {
			anuencia: {},
		}
	},
	computed: {
		naoConcluiu() {
			return this.anuencia.situacaoItemAdesao !== situacoes.ADESAO.CONCLUIDO.value
		},
	},
	methods: {
		async finalizarAnuencia() {
			try {
				await this.$store.dispatch(actionTypes.ANUENCIA.FINALIZAR, {
					idEmailAdesaoFornec: this.getControleAnuencia(),
				})
				await this.buscarDadosCabecalho()

				this.mostrarNotificacaoSucesso('Adesão finalizada com sucesso!')
			} finally {
				await this.buscarDadosCabecalho()
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
.mensagem-finalizar
	display flex
	flex-direction column
	align-items center
	padding 30px
	gap 30px

	.titulo
		font-weight bold
		color var(--v-primary-base)
		font-size 20px

	.box-aviso
		color var(--v-primary-base)
		font-weight bold
		display flex
		text-align center
		justify-content center
		flex-direction row
		align-items center
		align-content center
		width 100%

	.justificativa
		text-align justify
		color var(--v-primary-base)
		background-color var(--v-blue-lighten5)
		padding 10px
</style>
